(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9149],{

/***/ 51435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ information_section; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/ui/lib/ahm-ui.js
var ahm_ui = __webpack_require__(37169);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
;// CONCATENATED MODULE: ./src/client/components/sections/information-section/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  margin: 0 auto;\n  padding: 0 1rem;\n  row-gap: 1rem;\n\n  @media (min-width: ",
        ") {\n    gap: 1rem 1rem;\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  @media (min-width: ",
        ") {\n    grid-template-columns: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var media = ahm_ui/* theme.media */.rS.media;
var TileWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-1da72422-0"
})(_templateObject(), media.sm, media.md, function(param) {
    var tileThreshold = param.tileThreshold;
    return tileThreshold > 4 || tileThreshold === 3 ? "repeat(3, 1fr);" : "repeat(2, 1fr)";
});

// EXTERNAL MODULE: ./node_modules/@ahmdigital/logic/lib/content/utils/portable-text-to-plain/index.js
var portable_text_to_plain = __webpack_require__(64355);
var portable_text_to_plain_default = /*#__PURE__*/__webpack_require__.n(portable_text_to_plain);
;// CONCATENATED MODULE: ./src/client/components/information-tile/styles.js

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1.25rem;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 2rem;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 5rem;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  width: 35%;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-height: 100%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 65%;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-weight: bold;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  display: flex;\n  gap: 1rem;\n  padding: 2rem 1.5rem;\n\n  @media (min-width: ",
        ") {\n    max-height: 14rem;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var colors = ahm_ui/* theme.colors */.rS.colors, styles_media = ahm_ui/* theme.media */.rS.media;
var Title = (0,styled_components_browser_esm["default"])(ahm_ui.P).withConfig({
    componentId: "sc-add5b251-0"
})(styles_templateObject());
var CtaWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-add5b251-1"
})(_templateObject1());
var DescriptionWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-add5b251-2"
})(_templateObject2());
var ImageWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-add5b251-3"
})(_templateObject3());
var StyledImage = (0,styled_components_browser_esm["default"])(ahm_ui/* Image */.Ee).withConfig({
    componentId: "sc-add5b251-4"
})(_templateObject4());
var InformationWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-add5b251-5"
})(_templateObject5());
var StyledClickable = (0,styled_components_browser_esm["default"])(ahm_ui/* Clickable */.P3).withConfig({
    componentId: "sc-add5b251-6"
})(_templateObject6(), colors.purple);
var styles_TileWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-add5b251-7"
})(_templateObject7(), colors.grey20, styles_media.md);

;// CONCATENATED MODULE: ./src/client/components/information-tile/index.tsx





var InformationTile = function(param) {
    var image = param.image, subtitle = param.subtitle, title = param.title, urlObject = param.urlObject;
    var imageUrl = image === null || image === void 0 ? void 0 : image.src;
    var description = portable_text_to_plain_default()(subtitle);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_TileWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InformationWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                        variant: [
                            "bold",
                            "marginBottomSpacer11"
                        ],
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DescriptionWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                            children: description
                        })
                    }),
                    urlObject && /*#__PURE__*/ (0,jsx_runtime.jsx)(CtaWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledClickable, {
                            to: urlObject === null || urlObject === void 0 ? void 0 : urlObject.url,
                            children: urlObject === null || urlObject === void 0 ? void 0 : urlObject.name
                        })
                    })
                ]
            }),
            image && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImage, {
                    alt: image === null || image === void 0 ? void 0 : image.alt,
                    src: imageUrl
                })
            })
        ]
    });
};
/* harmony default export */ var information_tile = (InformationTile);

// EXTERNAL MODULE: ./src/client/components/sections/wrapped-section/index.tsx
var wrapped_section = __webpack_require__(51878);
;// CONCATENATED MODULE: ./src/client/components/sections/information-section/index.tsx








var InformationSection = function(param) {
    var content = param.content;
    var formattedContent = (0,fp.flatten)(content);
    if ((0,fp.isEmpty)(formattedContent)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(wrapped_section/* default */.Z, {
        withBorder: true,
        withWide: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H2, {
                variant: [
                    "center",
                    "marginBottomSpacer8"
                ],
                children: "Handy links"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TileWrapper, {
                tileThreshold: (0,fp.size)(formattedContent),
                children: (0,fp.map)(function(tile) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(information_tile, (0,_object_spread/* default */.Z)({}, tile));
                }, formattedContent)
            })
        ]
    });
};
/* harmony default export */ var information_section = (InformationSection);


/***/ }),

/***/ 27440:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37169);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_sass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87205);
/* harmony import */ var _styles_module_sass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_sass__WEBPACK_IMPORTED_MODULE_3__);




var TermsSection = function(param) {
    var _heading = param.heading, heading = _heading === void 0 ? "Things you should know" : _heading, _id = param.id, id = _id === void 0 ? "terms" : _id, termsComponent = param.termsComponent;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .BorderGridContainer */ .sO, {
        hideBorderTop: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .GridBox */ .zc, {
            padding: "1rem",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_sass__WEBPACK_IMPORTED_MODULE_3___default().wrapper),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .SpacerWrapper */ .Cj, {
                    variant: [
                        "paddingTopSpacer2",
                        "paddingBottomSpacer2"
                    ],
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .AxisSwitcher */ .e$, {
                        limit: 2,
                        threshold: "44rem",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .GridBox */ .zc, {
                                padding: "1rem",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    "data-testid": "terms-heading-wrapper",
                                    id: id,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__.H2, {
                                        looksLike: "h3",
                                        variant: "marginBottomSpacer9",
                                        children: heading
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .GridBox */ .zc, {
                                minWidth: "calc((100% / 10) * 6)",
                                padding: "1.5rem 1rem 1rem 1rem",
                                children: termsComponent
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TermsSection);


/***/ }),

/***/ 47828:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37169);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_sass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26717);
/* harmony import */ var _styles_module_sass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_sass__WEBPACK_IMPORTED_MODULE_4__);





// @ts-expect-error - Automatic, Please fix when editing this file
var wrapDescription = function(description) {
    return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_2__.isArray)(description) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .PortableText */ .YI, {
        source: description
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .Markdown */ .UG, {
        children: description
    });
};
var TermsAndConditions = function(param) {
    var terms = param.terms;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: (0,lodash_fp__WEBPACK_IMPORTED_MODULE_2__.map)(function(param) {
            var title = param.title, descriptionRaw = param.descriptionRaw, footnote = param.footnote, cta = param.cta;
            var hasCta = !(0,lodash_fp__WEBPACK_IMPORTED_MODULE_2__.isUndefined)(cta);
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
                children: [
                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__.H3, {
                        looksLike: "small",
                        variant: "marginBottomSpacer11",
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__.P, {
                        variant: hasCta ? "marginBottomSpacer10" : "marginBottomSpacer9",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .Small */ .x4, {
                            children: [
                                footnote && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    id: footnote.linkId,
                                    className: (_styles_module_sass__WEBPACK_IMPORTED_MODULE_4___default().footnotePrefix),
                                    children: footnote.reference
                                }),
                                wrapDescription(descriptionRaw)
                            ]
                        })
                    }),
                    hasCta && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .Clickable */ .P3, {
                        icon: {
                            name: cta.icon,
                            size: "small"
                        },
                        to: cta.url,
                        variant: "marginBottomSpacer9",
                        children: cta.title
                    })
                ]
            }, title);
        }, terms)
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TermsAndConditions);


/***/ }),

/***/ 59297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_terms_and_conditions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47828);
/* harmony import */ var _components_sections_terms_section__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27440);




var TermsAndConditions = function(param) {
    var terms = param.terms;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_sections_terms_section__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        termsComponent: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_terms_and_conditions__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            terms: terms
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TermsAndConditions);


/***/ }),

/***/ 58699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ CMS_CONTENT_SECTIONS; },
/* harmony export */   "i": function() { return /* binding */ CONTENT_SECTIONS; }
/* harmony export */ });
// order matters as it defined the order of the sections in the page
/* eslint-disable sort-keys */ var CONTENT_SECTIONS = {
    AWARD: "award",
    HEADER: "header",
    PROMOTIONS: "promotions",
    OFFER_STRIP: "offerStrip",
    COVER_INCLUSIONS: "coverInclusions",
    VALUE_PROPOSITIONS: "valuePropositionGroup",
    PRODUCTS: "productsByType",
    RELEVANT_ADD_ONS: "relevantAddOns",
    FEATURES_AND_BENEFITS: "featuresAndBenefits",
    INCLUSIONS: "inclusions",
    CONTACT_DETAILS: "contactDetails",
    ADD_ONS: "productConfigGroup",
    POPULAR_DESTINATIONS: "popularDestinations",
    COMMON_QUESTIONS_ALTERNATE: "commonQuestionsAlternate",
    TILES: "tiles",
    FORMS_AND_GUIDES: "formsAndGuides",
    COMMON_QUESTIONS: "commonQuestions",
    QUICK_LINKS: "quickLinks",
    CROSS_SELL: "crossSell",
    TERMS_AND_CONDITIONS: "termsAndConditions"
};
var CMS_CONTENT_SECTIONS = {
    HEADER: "brandCampaigns",
    PROMOTIONS: "promotions",
    OFFER_STRIP: "offer",
    VALUE_PROPOSITIONS: "valuePropositionGroup",
    FEATURES_AND_BENEFITS: "featuresAndBenefits",
    CONTACT_DETAILS: "contactDetails",
    TILES: "tiles",
    FORMS_AND_GUIDES: "formsAndGuides",
    COMMON_QUESTIONS: "questions",
    QUICK_LINKS: "quickLinks",
    TERMS_AND_CONDITIONS: "termsAndConditions",
    CROSS_SELL: "crossSell",
    PRODUCTS: "productsByType",
    ADD_ONS: "productConfigGroup",
    COMMON_QUESTIONS_ALTERNATE: "commonQuestions",
    RELEVANT_ADD_ONS: "relevantAddOns"
};


/***/ }),

/***/ 54310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _content_sections__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58699);
/* harmony import */ var _utils_get_formatted_question_for_accordion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80365);



// @ts-expect-error - Automatic, Please fix when editing this file
var mapCommonQuestionsContent = function(param) {
    var cmsSectionContent = param.cmsSectionContent;
    if ((0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isEmpty)(cmsSectionContent)) {
        // @ts-expect-error - Automatic, Please fix when editing this file
        return null;
    }
    return {
        isTwoColumn: false,
        items: (0,_utils_get_formatted_question_for_accordion__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(cmsSectionContent),
        type: _content_sections__WEBPACK_IMPORTED_MODULE_1__/* .CONTENT_SECTIONS.COMMON_QUESTIONS */ .i.COMMON_QUESTIONS
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (mapCommonQuestionsContent);


/***/ }),

/***/ 15543:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _content_sections__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58699);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19970);
/* harmony import */ var _cms_utils_get_image_attributes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51413);
/* harmony import */ var _map_offer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63086);





var mapHeaderContent = function(param) {
    var cmsSectionContent = param.cmsSectionContent, insuranceType = param.insuranceType, offerData = param.offerData;
    var ref, ref1;
    if ((0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isEmpty)(cmsSectionContent)) {
        return null;
    }
    var brandCampaign = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.head)(cmsSectionContent);
    var productReviewId = insuranceType ? _constants__WEBPACK_IMPORTED_MODULE_2__/* .PRODUCT_REVIEW_IDS */ .Or[(0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.lowerCase)(insuranceType)] : null;
    var showProductReviewWidget = !!productReviewId;
    var offer = (0,_map_offer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        cmsSectionContent: offerData
    });
    var mappedCmsContent = {
        cta: {
            title: brandCampaign === null || brandCampaign === void 0 ? void 0 : (ref = brandCampaign.urlObject) === null || ref === void 0 ? void 0 : ref.name,
            to: brandCampaign === null || brandCampaign === void 0 ? void 0 : (ref1 = brandCampaign.urlObject) === null || ref1 === void 0 ? void 0 : ref1.url
        },
        hasProductReviewWidget: showProductReviewWidget,
        image: (0,_cms_utils_get_image_attributes__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
            height: 480,
            imageObject: brandCampaign.imageObject
        }),
        offer: offer,
        subtitle: brandCampaign === null || brandCampaign === void 0 ? void 0 : brandCampaign.descriptionRaw,
        title: brandCampaign === null || brandCampaign === void 0 ? void 0 : brandCampaign.sloganRaw,
        type: _content_sections__WEBPACK_IMPORTED_MODULE_1__/* .CONTENT_SECTIONS.HEADER */ .i.HEADER
    };
    return mappedCmsContent;
};
/* harmony default export */ __webpack_exports__["Z"] = (mapHeaderContent);


/***/ }),

/***/ 63086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _content_sections__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58699);


var mapOffer = function(param) {
    var cmsSectionContent = param.cmsSectionContent;
    var ref, ref1, ref2, ref3;
    var offer = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.head)(cmsSectionContent);
    if ((0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isEmpty)(offer) || !offer.descriptionRaw) {
        return null;
    }
    var offerContent = {
        footnote: {
            linkId: offer.footnoteLinkSymbol ? "footnote-".concat(offer.footnoteLinkSymbol) : null,
            reference: offer.footnoteLinkSymbol || null
        },
        image: {
            alt: ((ref = offer.icon) === null || ref === void 0 ? void 0 : ref.caption) || null,
            src: ((ref1 = offer.icon) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.image) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.asset) === null || ref3 === void 0 ? void 0 : ref3.url) || null
        },
        title: offer.descriptionRaw,
        type: _content_sections__WEBPACK_IMPORTED_MODULE_1__/* .CONTENT_SECTIONS.OFFER_STRIP */ .i.OFFER_STRIP
    };
    return offerContent;
};
/* harmony default export */ __webpack_exports__["Z"] = (mapOffer);


/***/ }),

/***/ 77013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _content_sections__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58699);
/* harmony import */ var _ahm_constants_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93590);
/* harmony import */ var _cms_utils_get_image_attributes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51413);
/* harmony import */ var _utils_insert_footnote_reference__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74537);
/* harmony import */ var _utils_sort_tiles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2112);






var formatTiles = function(tiles) {
    return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.map)(function(tile) {
        var ref = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.pick)([
            "title",
            "subtitle",
            "footnote",
            "imageObject",
            "urlObject"
        ], tile), title = ref.title, subtitle = ref.subtitle, footnote = ref.footnote, imageObject = ref.imageObject, urlObject = ref.urlObject;
        var formattedFootnote = footnote ? {
            linkId: "footnote-".concat(footnote),
            reference: footnote
        } : null;
        var tileSubtitle = formattedFootnote ? (0,_utils_insert_footnote_reference__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            footnote: formattedFootnote,
            text: subtitle
        }) : subtitle;
        var cta = urlObject ? [
            {
                name: urlObject.name,
                url: urlObject.url
            }
        ] : null;
        var image = (0,_cms_utils_get_image_attributes__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
            height: 240,
            imageObject: imageObject
        });
        var formattedTile = {
            // @ts-expect-error - Automatic, Please fix when editing this file
            ctas: cta,
            // @ts-expect-error - Automatic, Please fix when editing this file
            footnote: formattedFootnote,
            image: !(0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isEmpty)(image) ? image : null,
            subtitle: tileSubtitle,
            title: title,
            // @ts-ignore - Automatic, Please fix when editing this file
            urlObject: urlObject
        };
        return formattedTile;
    }, tiles);
};
var mapTiles = function(param) {
    var cmsSectionContent = param.cmsSectionContent;
    var tiles = cmsSectionContent;
    if ((0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isEmpty)(tiles)) {
        return null;
    }
    // @ts-expect-error - Automatic, Please fix when editing this file
    var formattedTiles = formatTiles(tiles);
    var sortedTiles = (0,_utils_sort_tiles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(formattedTiles, _ahm_constants_ui__WEBPACK_IMPORTED_MODULE_2__.TILE_VARIANTS.VERTICAL_CENTER);
    return {
        content: sortedTiles,
        type: _content_sections__WEBPACK_IMPORTED_MODULE_1__/* .CONTENT_SECTIONS.TILES */ .i.TILES
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (mapTiles);


/***/ }),

/***/ 17146:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _content_sections__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58699);
/* harmony import */ var _cms_utils_get_image_attributes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51413);



var mapValuePropositionsContent = function(param) {
    var cmsSectionContent = param.cmsSectionContent;
    if ((0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isEmpty)(cmsSectionContent)) {
        return null;
    }
    var mappedCmsContent = {
        description: cmsSectionContent === null || cmsSectionContent === void 0 ? void 0 : cmsSectionContent.descriptionRaw,
        tiles: (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.map)(function(valueProposition) {
            return {
                cta: {
                    title: (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.getOr)(null, "urlObject.name", valueProposition),
                    to: (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.getOr)(null, "urlObject.url", valueProposition)
                },
                image: (0,_cms_utils_get_image_attributes__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                    height: 352,
                    imageObject: valueProposition === null || valueProposition === void 0 ? void 0 : valueProposition.imageObject
                }),
                summary: (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.get)("summaryRaw", valueProposition),
                title: (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.get)("sloganRaw", valueProposition)
            };
        }, cmsSectionContent === null || cmsSectionContent === void 0 ? void 0 : cmsSectionContent.valuePropositions),
        title: cmsSectionContent === null || cmsSectionContent === void 0 ? void 0 : cmsSectionContent.title,
        type: _content_sections__WEBPACK_IMPORTED_MODULE_1__/* .CONTENT_SECTIONS.VALUE_PROPOSITIONS */ .i.VALUE_PROPOSITIONS,
        withSimpleBit: false
    };
    return mappedCmsContent;
};
/* harmony default export */ __webpack_exports__["Z"] = (mapValuePropositionsContent);


/***/ }),

/***/ 96816:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29815);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);




var mapTermsAndConditions = function(cmsTermsAndConditions) {
    if (!cmsTermsAndConditions) {
        return [];
    }
    var footnotes = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.map)(function(footnote) {
        if (!footnote) {
            return null;
        }
        var descriptionRaw = footnote.descriptionRaw, linkReferenceSymbol = footnote.linkReferenceSymbol;
        return {
            descriptionRaw: descriptionRaw,
            footnote: {
                linkId: "footnote-".concat(linkReferenceSymbol),
                reference: linkReferenceSymbol || ""
            }
        };
    }, cmsTermsAndConditions.footnotes);
    return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.compact)([
        (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, cmsTermsAndConditions), {
            title: cmsTermsAndConditions.name || null
        })
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(footnotes)));
};
/* harmony default export */ __webpack_exports__["Z"] = (mapTermsAndConditions);


/***/ }),

/***/ 18971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



// @ts-expect-error - Automatic, Please fix when editing this file
var NextRedirect = function(param) {
    var to = param.to;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        router.push(to);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
var RedirectAdapter = function(param) {
    var to = param.to;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NextRedirect, {
        to: to
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RedirectAdapter);


/***/ }),

/***/ 2112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ahm_constants_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93590);




var sortTiles = function(tiles, tileVariant) {
    if ((0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isEmpty)(tiles) || !(0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isArray)(tiles)) {
        return [];
    }
    var rows = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.chunk)(2)(tiles);
    return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.map)(function(row) {
        return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.map)(function(tile) {
            if ((0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.size)(row) === 1) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, tile), {
                    variant: _ahm_constants_ui__WEBPACK_IMPORTED_MODULE_1__.TILE_VARIANTS.FULL_WIDTH
                });
            }
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, tile), {
                variant: tileVariant
            });
        })(row);
    })(rows);
};
/* harmony default export */ __webpack_exports__["Z"] = (sortTiles);


/***/ }),

/***/ 87205:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","wrapper":"styles_wrapper__iO1nP"};

/***/ }),

/***/ 26717:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","footnotePrefix":"styles_footnotePrefix__tLuT7"};

/***/ })

}]);